@if (!environment.int) {
  <eop-cookie-banner></eop-cookie-banner>
} @else {
  <eop-feature-flag-debug-panel></eop-feature-flag-debug-panel>
}
@if (!languagesLoaded) {
  <div class="initialization_overlay"></div>
}
<div
  class="app-container"
  [ngClass]="{ 'public-page': isAnonymousUserPages() && !initialChangeLanguageLoading && !loading }"
  [class.homepage]="inPage('/monitor/dashboard')">
  <div class="emob-backdrop-blur-filter" emobModalActive></div>
  @if (notification$ | async; as notification) {
    <div [ngClass]="{ 'top-notification-margin': !isAnonymousUserPages() }">
      <notification-top
        [level]="notification.notificationLevel"
        [message]="notification.message"
        [traceId]="notification.traceId"
        [closeButtonText]="'GLOBAL.NOTIFICATION_BUTTON_TEXT_UNDERSTAND' | translate"
        [reloadButtonText]="
          notification.reloadButton ? ('CHARG_INF_DETAIL.REFRESH' | translate) : ''
        "
        (closeNotification)="closeNotification()">
      </notification-top>
    </div>
  }

  @if (initialChangeLanguageLoading || loading) {
    <div class="initialization-spinner">
      <spinner [spinnerSize]="64"></spinner>
    </div>
  }

  @if ((languagesLoaded && isAnonymousUserPages()) || (!loading && !initialChangeLanguageLoading)) {
    <div
      [class.container-fluid]="!isAnonymousUserPages()"
      [class.no-sidebar-menu]="isPageWithoutMenu() || isAnonymousUserPages()"
      [class.sidebar-collapsed]="sidebarCollapsed">
      @if (!(isPageWithoutMenu() || isAnonymousUserPages())) {
        <eop-global-header class="app-header" [isFullWidth]="isFullWidthPage()"></eop-global-header>
      }

      <div class="app-content" [class.full-width]="isFullWidthPage()">
        <router-outlet></router-outlet>
        <eop-scroll-to-top
          class="
          scroll-to-top-button
          {{ userFlowActivated ? 'userflow-active' : '' }}
          {{ chatbotActivated ? 'chatbot-active' : '' }}
        "></eop-scroll-to-top>
      </div>
    </div>
  }
  @if (isPageWithoutMenu() || isAnonymousUserPages()) {
    <footer>
      <eop-footer> </eop-footer>
    </footer>
  }
</div>
